package org.zq.astrock_ai.api

/**
 * 荐股开通档位。认证码一次性核销；同设备再核销从「剩余到期」往后续期。
 */
enum class LicensePlan(
    val id: String,
    val days: Int,
    val prefix: String,
    val label: String,
) {
    WEEK("7d", 7, "A7", "一周"),
    MONTH("30d", 30, "M1", "一个月"),
    QUARTER("90d", 90, "Q3", "三个月"),
    HALF("180d", 180, "H6", "半年"),
    YEAR("365d", 365, "Y1", "一年"),
    ;

    companion object {
        fun fromId(raw: String?): LicensePlan? {
            val t = raw.orEmpty().trim().lowercase()
            return when (t) {
                "7d", "week", "一周", "7" -> WEEK
                "30d", "month", "一个月", "1个月", "30" -> MONTH
                "90d", "quarter", "三个月", "3个月", "90" -> QUARTER
                "180d", "half", "半年", "180" -> HALF
                "365d", "year", "一年", "365" -> YEAR
                else -> entries.firstOrNull { it.id == t || it.name.equals(t, ignoreCase = true) }
            }
        }

        fun fromCode(raw: String?): LicensePlan? {
            val code = normalizeCode(raw)
            val prefix = code.substringBefore('-', missingDelimiterValue = "")
            return entries.firstOrNull { it.prefix.equals(prefix, ignoreCase = true) }
        }

        fun normalizeCode(raw: String?): String =
            raw.orEmpty().uppercase().filter { it.isLetterOrDigit() || it == '-' }

        fun extendExpiresAt(nowMs: Long, currentExpiresAtMs: Long, addDays: Int): Long {
            val base = maxOf(nowMs, currentExpiresAtMs)
            return base + addDays.toLong() * 86_400_000L
        }

        /** 短信首次注册赠送天数，与 [MONTH] 一致 */
        const val TRIAL_DAYS = 30
        const val TRIAL_LABEL = "体验1个月"
    }
}
